module.exports = __webpack_public_path__ + "img/icbc.9a9a637a.svg";